import React, { useState } from 'react';
import { PlusIcon, TrashIcon } from 'lucide-react';
import { useForm } from '@formspree/react';
export function GiftForm() {
  const [state, handleFormspreeSubmit] = useForm('xvgdoolp'); // Replace with your Formspree form ID
  const [senderName, setSenderName] = useState('');
  const [senderEmail, setSenderEmail] = useState('');
  const [recipients, setRecipients] = useState([{
    name: '',
    email: '',
    address: '',
    city: '',
    state: '',
    zip: ''
  }]);
  const addRecipient = () => {
    setRecipients([...recipients, {
      name: '',
      email: '',
      address: '',
      city: '',
      state: '',
      zip: ''
    }]);
  };
  const removeRecipient = index => {
    const newRecipients = [...recipients];
    newRecipients.splice(index, 1);
    setRecipients(newRecipients);
  };
  const handleChange = (index, field, value) => {
    const newRecipients = [...recipients];
    newRecipients[index][field] = value;
    setRecipients(newRecipients);
  };
  const handleSubmit = async e => {
    e.preventDefault();
    // Format recipients data for readable email
    const formattedRecipients = recipients.map((recipient, index) => {
      return `
Recipient ${index + 1}:
  Name: ${recipient.name}
  Email: ${recipient.email}
  Address: ${recipient.address}
  City: ${recipient.city}
  State: ${recipient.state}
  ZIP: ${recipient.zip}
        `.trim();
    }).join('\n\n');
    // Create form data with formatted recipients
    const formData = new FormData();
    formData.append('senderName', senderName);
    formData.append('senderEmail', senderEmail);
    formData.append('recipients', formattedRecipients);
    // Submit to Formspree
    await handleFormspreeSubmit(formData);
  };
  if (state.succeeded) {
    return <section id="gift-form" className="py-16 px-6 bg-white" data-id="element-34">
        <div className="max-w-4xl mx-auto" data-id="element-35">
          <div className="bg-white rounded-lg shadow-xl p-8 border border-gray-200 text-center" data-id="element-36">
            <div className="mb-6" data-id="element-37">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-38">
                <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-39">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-40" />
                </svg>
              </div>
              <h2 className="text-3xl font-bold text-[#1E3A5F] mb-4" data-id="element-41">
                Thank You!
              </h2>
              <p className="text-lg text-gray-700 mb-4" data-id="element-42">
                Your gift books will be sent to your recipients. We appreciate
                you sharing the gift of wisdom!
              </p>
              <button onClick={() => window.location.reload()} className="bg-[#1E3A5F] hover:bg-[#162b45] text-white font-medium py-2 px-6 rounded-md transition-colors" data-id="element-43">
                Send More Books
              </button>
            </div>
          </div>
        </div>
      </section>;
  }
  return <section id="gift-form" className="py-16 px-6 bg-white" data-id="element-44">
      <div className="max-w-4xl mx-auto" data-id="element-45">
        <div className="bg-white rounded-lg shadow-xl p-8 border border-gray-200" data-id="element-46">
          <div className="text-center mb-10" data-id="element-47">
            <h2 className="text-3xl font-bold text-[#1E3A5F] mb-4" data-id="element-48">
              Send the Gift of Wisdom
            </h2>
            <p className="text-gray-600 mb-3" data-id="element-49">
              There is no limit to the number of copies you can share. We'll
              handle the shipping.
            </p>
            <p className="text-sm text-gray-500 bg-gray-50 border border-gray-200 rounded-md py-2 px-4 inline-block" data-id="element-50">
              <strong data-id="element-51">Note:</strong> This offer is available for United
              States-based addresses only. We cannot ship internationally.
            </p>
          </div>
          {state.errors && state.errors.length > 0 && <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-md" data-id="element-52">
              <p className="text-red-700" data-id="element-53">
                Something went wrong. Please try again.
              </p>
            </div>}
          <form onSubmit={handleSubmit} data-id="element-54">
            <div className="mb-6" data-id="element-55">
              <label htmlFor="sender-name" className="block text-gray-700 font-medium mb-2" data-id="element-56">
                Your Name
              </label>
              <input type="text" id="sender-name" name="senderName" value={senderName} onChange={e => setSenderName(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]" required data-id="element-57" />
            </div>
            <div className="mb-6" data-id="element-58">
              <label htmlFor="sender-email" className="block text-gray-700 font-medium mb-2" data-id="element-59">
                Your Email
              </label>
              <input type="email" id="sender-email" name="senderEmail" value={senderEmail} onChange={e => setSenderEmail(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]" required data-id="element-60" />
            </div>
            <div className="mb-10" data-id="element-61">
              <div className="flex justify-between items-center mb-4" data-id="element-62">
                <h3 className="text-xl font-semibold text-[#1E3A5F]" data-id="element-63">
                  Recipients
                </h3>
                <button type="button" onClick={addRecipient} className="flex items-center text-[#1E3A5F] hover:text-[#E85C41] transition-colors" data-id="element-64">
                  <PlusIcon size={16} className="mr-1" data-id="element-65" />
                  Add Another Recipient
                </button>
              </div>
              {recipients.map((recipient, index) => <div key={index} className="p-6 mb-6 border border-gray-200 rounded-lg bg-gray-50" data-id="element-66">
                  <div className="flex justify-between items-start mb-4" data-id="element-67">
                    <h4 className="font-medium" data-id="element-68">Recipient {index + 1}</h4>
                    {recipients.length > 1 && <button type="button" onClick={() => removeRecipient(index)} className="text-red-500 hover:text-red-700" data-id="element-69">
                        <TrashIcon size={16} data-id="element-70" />
                      </button>}
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-71">
                    <div data-id="element-72">
                      <label className="block text-gray-700 text-sm font-medium mb-1" data-id="element-73">
                        Name
                      </label>
                      <input type="text" value={recipient.name} onChange={e => handleChange(index, 'name', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]" required data-id="element-74" />
                    </div>
                    <div data-id="element-75">
                      <label className="block text-gray-700 text-sm font-medium mb-1" data-id="element-76">
                        Email
                      </label>
                      <input type="email" value={recipient.email} onChange={e => handleChange(index, 'email', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]" required data-id="element-77" />
                    </div>
                    <div className="md:col-span-2" data-id="element-78">
                      <label className="block text-gray-700 text-sm font-medium mb-1" data-id="element-79">
                        Address
                      </label>
                      <input type="text" value={recipient.address} onChange={e => handleChange(index, 'address', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]" required data-id="element-80" />
                    </div>
                    <div data-id="element-81">
                      <label className="block text-gray-700 text-sm font-medium mb-1" data-id="element-82">
                        City
                      </label>
                      <input type="text" value={recipient.city} onChange={e => handleChange(index, 'city', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]" required data-id="element-83" />
                    </div>
                    <div className="grid grid-cols-2 gap-2" data-id="element-84">
                      <div data-id="element-85">
                        <label className="block text-gray-700 text-sm font-medium mb-1" data-id="element-86">
                          State
                        </label>
                        <input type="text" value={recipient.state} onChange={e => handleChange(index, 'state', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]" required data-id="element-87" />
                      </div>
                      <div data-id="element-88">
                        <label className="block text-gray-700 text-sm font-medium mb-1" data-id="element-89">
                          ZIP
                        </label>
                        <input type="text" value={recipient.zip} onChange={e => handleChange(index, 'zip', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]" required data-id="element-90" />
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="text-center" data-id="element-91">
              <button type="submit" disabled={state.submitting} className="bg-[#E85C41] hover:bg-[#d04b32] text-white font-bold py-3 px-8 rounded-md text-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-92">
                {state.submitting ? 'Sending...' : 'Send Books'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>;
}